import {getConfigItem, configConstants, observeConfigItem} from '@servicenow/ui-config';
import logObservers from './logObservers';
import {defer, whenIdle} from '@servicenow/ui-utils';

const {LOGS_OBSERVER_INTERVAL} = configConstants;
let timeoutId;
let logsObserverInterval = getConfigItem(LOGS_OBSERVER_INTERVAL);

const observer = (path, value) => {
	if (path === LOGS_OBSERVER_INTERVAL) {
		logsObserverInterval = value;
	}
};

observeConfigItem(LOGS_OBSERVER_INTERVAL, observer);

const addLog = logContext => {
	for (const observer of logObservers) observer.logsToSend.push(logContext);
};

const notifyLogObserver = observer => {
	const {logsToSend} = observer;
	observer.observer(logsToSend.splice(0, logsToSend.length));
};

export default function notifyLogObservers(logContext) {
	if (logObservers.size) {
		let timeExpired = false;
		if (logContext) addLog(logContext);
		clearTimeout(timeoutId);
		timeoutId = defer(() => {
			whenIdle(deadLine => {
				for (const observer of logObservers) {
					if (deadLine.timeRemaining() > 0) {
						if (observer.logsToSend.length) notifyLogObserver(observer);
					} else {
						timeExpired = true;
						break;
					}
				}

				if (timeExpired) notifyLogObservers();
			});
		}, logsObserverInterval || 1000);
	}
}
